<template>
  <div class="mod-show-table">
    <el-table
      v-if="!loading || listData.list"
      :data="listData.list"
      stripe
      style="width: 100%"
      header-cell-class-name="table-header-cell"
    >
      <el-table-column
        v-for="column in listData.head"
        :key="column.key"
        :prop="column.key"
        :label="column.name"
        :fixed="column.fixed"
        :width="column.width"
      >
        <template slot-scope="scope">
          <div v-if="column.type==='action'">
            <el-button 
              v-for="btn in (column.actionList || scope.row[column.key] || [])"
              :key="btn.key"
              type="text" 
              size="medium"
              @click="handleClick('actionClick', btn, scope.row)" 
            >
              {{ btn.name }}
            </el-button>
            <span
              v-if="!(column.actionList || scope.row[column.key] || []).length"
            >
              —
            </span>
          </div>
          <template
            v-else-if="column.type==='link' && (!column.disabledKey || (column.disabledKey && !scope.row[column.disabledKey]))"
          >
            <el-button
              v-if="scope.row[column.key]"
              type="text" 
              size="medium"
              @click="handleClick('linkClick', column, scope.row)"
            >
              {{ column.btnText || scope.row[column.key] }}
            </el-button>
            <span v-else>--</span>
          </template>
          <span v-else>{{ scope.row[column.key] }}</span>
        </template>
      </el-table-column>
    </el-table>
    <div 
      v-if="pageShow"
      class="page-footer-box"
    >
      <i class="line" />
      <el-pagination
        :current-page="listData.currentPage"
        :page-sizes="pageSizes"
        :page-size="pageSize"
        :layout="layout.join(', ')"
        :total="listData.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      default: true,
    },
    listData: {
      default: () => {
        return {
          head: [],
          list: [],
          currentPage: 1,
          total: 0,
        };
      },
    },
    pageSize: {
      default: 10,
    },
    pageSizes: {
      default: () => {
        return [10, 20, 30];
      },
    },
    pageShow: {
      default: true,
    },
    layout: {
      default: () => {
        return ['total', 'sizes', 'prev', 'pager', 'next', 'jumper'];
      },
    },
  },
  methods: {
    handleClick() {
      this.$emit(...arguments);
    },
    handleSizeChange(size) {
      this.$emit('pageSizeChange', size);
      console.log(`每页 ${size} 条`);
    },
    handleCurrentChange(page) {
      this.$emit('pageChange', page);
      console.log(`当前页: ${page}`);
    },
  },
};
</script>

<style lang="scss">
.mod-show-table {
  width: 100%;
  .el-table {
    .table-header-cell {
      background: rgba(230, 230, 230, 1);
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
    }
  }
  .page-footer-box {
    display: flex;
    align-items: center;
    margin-top: 17px;
    .line {
      flex-grow: 1;
      display: inline-block;
      height: 1px;
      margin-right: 10px;
      background: #dcdfe6;
    }
  }
}
</style>